export const FORM_ACTION = 'FORM_ACTION';
export const FORM_SECONDARY_ACTION = 'FORM_SECONDARY_ACTION';
export const FORM_REFRESH = 'FORM_REFRESH';
export const FORM_BOUNCE_EDIT = 'FORM_BOUNCE_EDIT';
export const SET_USER = 'SET_USER';
